import React from 'react';
import BaseModal, {
	BaseModalProps,
} from '../../../Base/Components/BaseModal/BaseModal';
import InsuranceReportDetail from './InsuranceReportDetail';

interface Props extends BaseModalProps {
	insuranceReportId: string;
}

const InsuranceReportDetailModal: React.FC<Props> = props => {
	return (
		<BaseModal title='base.insuranceReport' {...props}>
			<InsuranceReportDetail insuranceReportId={props.insuranceReportId} />
		</BaseModal>
	);
};

export default InsuranceReportDetailModal;
